var subscribe_ready;

subscribe_ready = function () {
  $("#new_subscribe").submit(function () {
    $("#subscribe-info")
      .html("Subscribing…")
      .removeClass("error")
      .addClass("active");
  });
  return $("#new_subscribe")
    .bind("ajax:error", function (xhr, status, error) {
      if (status.status === 201) {
        $("#subscribe-info").removeClass("error").html("Thank you.");
        return $("#subscribe_email").val("");
      } else if (status.status === 422) {
        return $("#subscribe-info")
          .addClass("error")
          .html("Invalid email address.");
      } else {
        return $("#subscribe-info")
          .addClass("error")
          .html("Service unavailable. Please try again later.");
      }
    })
    .bind("ajax:complete", function () {});
};

$(document).ready(subscribe_ready);

$(document).on("page:load", subscribe_ready);

// ---
// generated by coffee-script 1.9.2
